import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RequestQuery {
    category: string;
    list_no: string;
}

interface RequestBody {
    subject: string;
    contents: string;
    company: string;
    mobile: string;
    address: string;
    status: string;
    // notice: number;
    // b_file: File[];
}

export type UpdateRequest = RequestQuery & RequestBody;

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

const createFormData = (data: RequestBody) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof RequestBody];

        if (key === "b_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("b_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value?.toString());
        }
    });

    return formData;
};

export const usePutConsoleSupplies = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();
    const headers = {
        "Content-Type": "multipart/form-data",
    };

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_supplies.replace(":category", updateData.category).replace(":list_no", updateData.list_no);
            const formData = createFormData({
                subject: updateData.subject,
                contents: updateData.contents,
                company: updateData.company,
                mobile: updateData.mobile,
                address: updateData.address,
                status: updateData.status,
                // notice: updateData.notice,
                // b_file: updateData.b_file,
            });
            const response = await axiosInstance.put(url, formData, { headers });
            return response.data.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleSupplies", "useGetConsoleSuppliesDetail"] });
            successCallback?.(data);
        },
    });
};
